export default __webpack_public_path__ + "images/4bb3f17cf882c27b10e55cfb402f1759-iconos_tik-tok.svg";